import { MethodOptions } from 'vue';

export interface Address{
    streetAddress: string;
    suite: string;
    city: string;
    state: string;
    zipCode: string;
}

interface AddressMethods extends MethodOptions {
    validateAddressFieldsExist(address: Address): boolean;
    fullAddress(address: Address): string;
    addressLine2(address: Address): string;
    addressLine3(address: Address): string;
}


export const addressMixin = {
    methods: {
        validateAddressFieldsExist(address: Address): boolean {
            return !!(address.streetAddress && address.city && address.state && address.zipCode);
        },
        fullAddress(address: Address): string {
            const addrLine2 = (this as AddressMethods).addressLine2(address);
            const addrLine3 = (this as AddressMethods).addressLine3(address);

            if (addrLine2.length > 0 && addrLine3.length > 0) {
                return `${addrLine2}, ${addrLine3}`;
            } else if (addrLine2.length > 0) {
                return addrLine2;
            } else {
                return addrLine3;
            }
        },
        addressLine2(address: Address): string {
            let addressStr = '';
            if (address) {
                if (address.streetAddress) {
                    addressStr += address.streetAddress;
                }

                if (address.suite) {
                    addressStr += ', ' + address.suite; 
                }
            }
            return addressStr.trim();
        },
        addressLine3(address: Address): string {
            let addressStr = '';
            if (address) {
                if (address.city) {
                    addressStr += address.city + ', ';
                }
                if (address.state) {
                    addressStr += address.state + ' ';
                }
                if (address.zipCode) {
                    addressStr += address.zipCode + ' ';
                }
            }

            return addressStr.trim();
        },
    } as AddressMethods,
};